import React, { useEffect } from "react";
import { X } from "lucide-react";

function TargetTypeWizardModal({
    title,
    subtitle,
    onClose,
    onBack,
    onSubmit,
    submitLabel = "Save",
    submitDisabled = false,
    contentClassName = "",
    children
}) {
    useEffect(() => {
        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        return () => {
            document.body.style.overflow = originalOverflow;
        };
    }, []);

    const formContentClassName = [
        "target-type-wizard-form__content",
        contentClassName
    ].filter(Boolean).join(" ");
    const closeAction = onBack || onClose;

    return (
        <div className="modal oct_display-block modal-v2-root">
            <div className="modal oct_modal modal-v2-overlay">
                <div className="modal-dialog modal-dialog-centered modal-v2-dialog target-type-wizard-modal-dialog" aria-modal="true">
                    <div className="modal-content modal-v2-shell target-type-wizard-modal">
                        <div className="modal-v2-header target-type-wizard-modal__header">
                            <div className="modal-v2-header-top">
                                <div className="modal-v2-header-copy">
                                    <h2 className="modal-v2-heading target-type-wizard-modal__title">{title}</h2>
                                    {subtitle ? (
                                        <p className="modal-v2-subheading target-type-wizard-modal__subtitle">{subtitle}</p>
                                    ) : null}
                                </div>
                            </div>
                            <button
                                type="button"
                                className="modal-v2-close target-type-wizard-modal__close"
                                aria-label="Close"
                                onClick={closeAction}
                            >
                                <X size={20} />
                            </button>
                        </div>
                        <div className="modal-body modal-v2-body target-type-wizard-modal__body">
                            <form
                                id="target-type-wizard-form"
                                className="target-type-wizard-form"
                                autoComplete="off"
                                onSubmit={(event) => {
                                    event.preventDefault();
                                    onSubmit();
                                }}
                            >
                                <div className={formContentClassName}>
                                    {children}
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer modal-v2-footer target-type-wizard-modal__footer">
                            <div className="modal-v2-footer-note">
                                <span className="modal-v2-footer-note-star">*</span>
                                Required fields
                            </div>
                            <div className="modal-v2-footer-actions target-type-wizard-modal__actions">
                                {typeof onBack === "function" ? (
                                    <button
                                        type="button"
                                        className="modal-v2-btn modal-v2-btn-outline"
                                        onClick={onBack}
                                    >
                                        Back
                                    </button>
                                ) : null}
                                <button
                                    type="button"
                                    className="modal-v2-btn modal-v2-btn-outline"
                                    onClick={onClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    form="target-type-wizard-form"
                                    className="modal-v2-btn modal-v2-btn-primary"
                                    disabled={submitDisabled}
                                >
                                    {submitLabel}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TargetTypeWizardModal;
